module.exports = __webpack_public_path__ + "img/handling-massive-product-db-in-magento.7374031e.webp";